$('.tp-collection-tab-heading-tab .tp-collection-tab').on('click', function(){
      var target = $(this).attr('data-rel');
      console.log('target',target);
      $('.tp-collection-tab-heading-tab .tp-collection-tab').removeClass('active');
      $(this).addClass('active');
      $(".tp-collection-tab-body .tp-collection-info-container").removeClass('active');
      $(".tp-collection-tab-body .tp-collection-info-container."+target).addClass('active');
    if ($('.homepage-product-grid1').hasClass('slick-initialized')) {
		$('.homepage-product-grid1').slick('destroy');
      $('.homepage-product-grid1').slick({
        dots: true,
        arrows: true,
    		infinite: false,
    		slidesToScroll: 1,
    		slidesToShow: 2,
            prevArrow:'<button class="slick-prev pull-left"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 9L1 5L5 1" stroke="#31302F" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow:'<button class="slick-next pull-right"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 9L5 5L1 1" stroke="#31302F" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    		responsive: [
    			{
    				breakpoint: 567,
    				settings: {
    					slidesToScroll: 2,
    					slidesToShow: 2,
                      dots: true,
    				}
    			}
    		]
      });
	}
});

// Quick view
$( document ).on( 'click', '.trigger-quick-view' , function(e) {
  e.preventDefault();
  var bab_modal_id = $(this).attr('data-modal');
  $('.modal__overlay').css('display','none');
  $('.modal__overlay').css('opacity','0');
  $('#'+bab_modal_id).css('display','block');
  $('#'+bab_modal_id).css('opacity','1');

  // var bab_modal_id = $(this).attr('data-modal');
  // var bab_modal_variant_id = $('#'+bab_modal_id +' '+'.no-js option:selected').val();
  // $('#'+bab_modal_id +' '+'.bab_add_to_cart_btn').attr('data-variant-id', bab_modal_variant_id);
  
});

//tooltip
$(".homapage-banner-tooltip-icon").click(function(){
  $(this).next().toggleClass("tooltipopen");
});


$('.homepage-product-grid1').slick({
    dots: true,
    arrows: true,
		infinite: false,
		slidesToScroll: 1,
		slidesToShow: 2,
        prevArrow:'<button class="slick-prev pull-left"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 9L1 5L5 1" stroke="#31302F" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow:'<button class="slick-next pull-right"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 9L5 5L1 1" stroke="#31302F" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
		responsive: [
			{
				breakpoint: 567,
				settings: {
					slidesToScroll: 2,
					slidesToShow: 2,
                  dots: true,
				}
			}
		]
  });


var $status = $('.pagingInfo');
var $slickElement = $('.slick-show');

$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  // no dots -> no slides
  if(!slick.$dots){
    return;
  }
  
  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  var i = (currentSlide ? currentSlide : 0) + 1;
  // use dots to get some count information
  $status.text(i + '/' + (slick.$dots[0].children.length));
});

$slickElement.slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  centerMode: true,
});

var win = $(window);
var slider = $(".collection-slick");

function initSlickInMobile(mobileMedia) {
  if (mobileMedia.matches) { // If media query matches
    slider.not(".slick-initialized").slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        autoplay: false,
      });
  } else {
    if (slider.hasClass("slick-initialized")) {
      slider.slick("unslick");
    }
  }
}

var mobileMedia = window.matchMedia("(max-width: 576px)")
initSlickInMobile(mobileMedia); // Call listener function at run time
mobileMedia.addListener(initSlickInMobile);


$('.homepage-product-grid2').slick({
    dots: true,
    arrows: true,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        prevArrow:'<button class="slick-prev pull-left"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 9L1 5L5 1" stroke="#31302F" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow:'<button class="slick-next pull-right"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 9L5 5L1 1" stroke="#31302F" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToScroll: 2,
                    slidesToShow: 2,
                  dots: true,
                  autoplay: true,
                }
            }
        ]
  });



$('.tp-collection-tab-heading-tab .tp-collection-tab').click(function(){
  if ($(window).width() < 992 ) {
      $('.tp-collection-tab-heading-tab').toggleClass("expend");
  }
});

//footer
jQuery('.new-footer-link-box h4').click(function(){	
    if (jQuery(window).width() < 768 ) {
        jQuery(this).next().slideToggle(300);
        jQuery(this).toggleClass("active");
    }
});

// Header mobile related script

/*** Account form Forgot password and Login form toggle  **/
$( document ).on( 'click', '.forgot_password' , function(e) {
  $(".header-reset-password").css("display","block");
  $(".header-login").css("display","none");
})

$( document ).on( 'click', '.backToLogin' , function(e) {
  $(".header-reset-password").css("display","none");
  $(".header-login").css("display","block");
})

//footer
$( document ).on( 'click', '.widget-title.accordion-title' , function(e) {
        $(this).next().slideToggle(300);
        $(this).toggleClass("mobile-toggle");
});


//model hide
$(".modal__overlay.quicklook button.close-modal").click(function(){
  $(".modal__overlay.quicklook").hide();
});


// $('ul.product__media-list').lightGallery({
//     thumbnail: true,
// });

//acordian product page
jQuery('.product_tabs .tab-item h2').click(function(){	
        jQuery(this).next().slideToggle(300);
        jQuery(this).parent().toggleClass("active");
});

$( document ).ready(function() {
   if(typeof lightGallery != "undefined") {
    var imageSrc = [];
    $( ".product__media-item .product__media" ).each(function( index ) {
       var imgObj = {};
       imgObj.src = $( this ).find('img').attr('src');
       imgObj.thumb = $( this ).find('img').attr('src');
       imgObj.alt = $( this ).find('img').attr('alt');
       imageSrc.push(imgObj);
    });
    console.log(imageSrc);
    const $dynamicGallery = document.querySelectorAll('.product__media-list ')[0];
    const dynamicGallery = lightGallery($dynamicGallery, {
        dynamic: true,
        plugins: [lgThumbnail],
        dynamicEl:imageSrc,
        mobileSettings: {
          controls: true,
          showCloseIcon: true,
          download: true,
          rotate: true
        }
    });
   
   document.querySelectorAll('.lg-thumb-item img').forEach((img, index) => {
    img.setAttribute('alt', imageSrc[index]?.alt || "Image");
  });
  var lightBoxButton = document.querySelectorAll('.slider-mobile-gutter .product__media-zoom-lightbox');
   
    for (let i = 0; i < lightBoxButton.length; i++) {
       lightBoxButton[i].addEventListener("click", function() {
         dynamicGallery.openGallery(i);
       });
   }

   var lightBoxButtonMobile = document.querySelectorAll('#mobile_product_slider .product__media-toggle.quick-add-hidden.product__media-zoom-lightbox');
   
    for (let i = 0; i < lightBoxButtonMobile.length; i++) {
       lightBoxButtonMobile[i].addEventListener("click", function() {
         var imagePosition = parseInt($(this).attr('data-position')) - 1;
         dynamicGallery.openGallery(imagePosition);
       });
   }
   }

  });


// BAB-JULY-5052 Home Page New Sections

// compare images js starts here

document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".image-compare-wrapper #comparison");
  const overlay = document.querySelector(".image-compare-wrapper #overlay-j");
  const handle = document.querySelector(".image-compare-wrapper #handle");

  let isDragging = false;

  function updateSlider(x) {
    const rect = container.getBoundingClientRect();
    let offsetX = x - rect.left;
    offsetX = Math.max(0, Math.min(offsetX, rect.width));
    const percent = (offsetX / rect.width) * 100;

    overlay.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
    handle.style.left = `${percent}%`;
  }

  // Mouse Events
  handle.addEventListener("mousedown", () => isDragging = true);
  document.addEventListener("mouseup", () => isDragging = false);
  document.addEventListener("mousemove", (e) => {
    if (isDragging) updateSlider(e.clientX);
  });

  // Touch Events
  handle.addEventListener("touchstart", () => isDragging = true);
  document.addEventListener("touchend", () => isDragging = false);
  document.addEventListener("touchmove", (e) => {
    if (isDragging && e.touches.length === 1) {
      updateSlider(e.touches[0].clientX);
    }
  });
});


// add class after 5slider

document.addEventListener("DOMContentLoaded", function () {
     const tabs = document.querySelectorAll(".best-selling-wrapper .tab-inner");
    let current = 0;
    let interval;

    function activateTab(index) {
      tabs.forEach((tab, i) => {
        tab.classList.toggle("active", i === index);
      });
    }

    function startAutoSwitching() {
      interval = setInterval(() => {
        current = (current + 1) % tabs.length;
        activateTab(current);
      }, 5000);
    }

    function stopAutoSwitching() {
      clearInterval(interval);
    }

    // Start initially
    activateTab(current);
    startAutoSwitching();

    // Add hover behavior
    tabs.forEach((tab, index) => {
      tab.addEventListener("mouseenter", () => {
        stopAutoSwitching();
        current = index;
        activateTab(current);
      });

      tab.addEventListener("mouseleave", () => {
        startAutoSwitching();
      });
    });

  });